function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
// ------------------ Helpers
function isNumber(n) {
  var number = parseFloat(n);
  return !isNaN(number) && isFinite(number);
}
function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height[height.length - 1] === '%' && isNumber(height.substring(0, height.length - 1));
}
function hideContent(element, height) {
  // Check for element?.style is added cause this would fail in tests (react-test-renderer)
  // Read more here: https://github.com/Stanko/react-animate-height/issues/17
  if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) {
    element.style.display = 'none';
  }
}
function showContent(element, height) {
  // Check for element?.style is added cause this would fail in tests (react-test-renderer)
  // Read more here: https://github.com/Stanko/react-animate-height/issues/17
  if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) {
    element.style.display = '';
  }
}
var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};
function getStaticStateClasses(animationStateClasses, height) {
  return [animationStateClasses.static, height === 0 && animationStateClasses.staticHeightZero, height > 0 && animationStateClasses.staticHeightSpecific, height === 'auto' && animationStateClasses.staticHeightAuto].filter(function (v) {
    return v;
  }).join(' ');
}
// ------------------ Component
var propsToOmitFromDiv = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'className', 'contentClassName', 'delay', 'duration', 'easing', 'height', 'onHeightAnimationEnd', 'onHeightAnimationStart', 'style'];
var AnimateHeight = function AnimateHeight(componentProps) {
  var _componentProps$anima = componentProps.animateOpacity,
    animateOpacity = _componentProps$anima === void 0 ? false : _componentProps$anima,
    _componentProps$anima2 = componentProps.animationStateClasses,
    animationStateClasses = _componentProps$anima2 === void 0 ? {} : _componentProps$anima2,
    _componentProps$apply = componentProps.applyInlineTransitions,
    applyInlineTransitions = _componentProps$apply === void 0 ? true : _componentProps$apply,
    children = componentProps.children,
    _componentProps$class = componentProps.className,
    className = _componentProps$class === void 0 ? '' : _componentProps$class,
    contentClassName = componentProps.contentClassName,
    _componentProps$delay = componentProps.delay,
    userDelay = _componentProps$delay === void 0 ? 0 : _componentProps$delay,
    _componentProps$durat = componentProps.duration,
    userDuration = _componentProps$durat === void 0 ? 500 : _componentProps$durat,
    _componentProps$easin = componentProps.easing,
    easing = _componentProps$easin === void 0 ? 'ease' : _componentProps$easin,
    height = componentProps.height,
    onHeightAnimationEnd = componentProps.onHeightAnimationEnd,
    onHeightAnimationStart = componentProps.onHeightAnimationStart,
    style = componentProps.style;
  var divProps = Object.assign({}, componentProps);
  propsToOmitFromDiv.forEach(function (propKey) {
    delete divProps[propKey];
  });
  // ------------------ Initialization
  var prevHeight = useRef(height);
  var contentElement = useRef(null);
  var animationClassesTimeoutID = useRef();
  var timeoutID = useRef();
  var stateClasses = useRef(Object.assign(Object.assign({}, ANIMATION_STATE_CLASSES), animationStateClasses));
  var isBrowser = typeof window !== 'undefined';
  var prefersReducedMotion = useRef(isBrowser && window.matchMedia ? window.matchMedia('(prefers-reduced-motion)').matches : false);
  var delay = prefersReducedMotion.current ? 0 : userDelay;
  var duration = prefersReducedMotion.current ? 0 : userDuration;
  var initHeight = height;
  var initOverflow = 'visible';
  if (typeof initHeight === 'number') {
    // Reset negative height to 0
    initHeight = height < 0 ? 0 : height;
    initOverflow = 'hidden';
  } else if (isPercentage(initHeight)) {
    // If value is string "0%" make sure we convert it to number 0
    initHeight = height === '0%' ? 0 : height;
    initOverflow = 'hidden';
  }
  var _useState = useState(initHeight),
    _useState2 = _slicedToArray(_useState, 2),
    currentHeight = _useState2[0],
    setCurrentHeight = _useState2[1];
  var _useState3 = useState(initOverflow),
    _useState4 = _slicedToArray(_useState3, 2),
    overflow = _useState4[0],
    setOverflow = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    useTransitions = _useState6[0],
    setUseTransitions = _useState6[1];
  var _useState7 = useState(getStaticStateClasses(stateClasses.current, height)),
    _useState8 = _slicedToArray(_useState7, 2),
    animationStateClassNames = _useState8[0],
    setAnimationStateClassNames = _useState8[1];
  // ------------------ Did mount
  useEffect(function () {
    // Hide content if height is 0 (to prevent tabbing into it)
    hideContent(contentElement.current, currentHeight);
    // This should be explicitly run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ------------------ Height update
  useEffect(function () {
    if (height !== prevHeight.current && contentElement.current) {
      showContent(contentElement.current, prevHeight.current);
      // Cache content height
      contentElement.current.style.overflow = 'hidden';
      var contentHeight = contentElement.current.offsetHeight;
      contentElement.current.style.overflow = '';
      // set total animation time
      var totalDuration = duration + delay;
      var newHeight;
      var timeoutHeight;
      var timeoutOverflow = 'hidden';
      var timeoutUseTransitions;
      var isCurrentHeightAuto = prevHeight.current === 'auto';
      if (typeof height === 'number') {
        // Reset negative height to 0
        newHeight = height < 0 ? 0 : height;
        timeoutHeight = newHeight;
      } else if (isPercentage(height)) {
        // If value is string "0%" make sure we convert it to number 0
        newHeight = height === '0%' ? 0 : height;
        timeoutHeight = newHeight;
      } else {
        // If not, animate to content height
        // and then reset to auto
        newHeight = contentHeight; // TODO solve contentHeight = 0
        timeoutHeight = 'auto';
        timeoutOverflow = undefined;
      }
      if (isCurrentHeightAuto) {
        // This is the height to be animated to
        timeoutHeight = newHeight;
        // If previous height was 'auto'
        // set starting height explicitly to be able to use transition
        newHeight = contentHeight;
      }
      // Animation classes
      var newAnimationStateClassNames = [stateClasses.current.animating, (prevHeight.current === 'auto' || height < prevHeight.current) && stateClasses.current.animatingUp, (height === 'auto' || height > prevHeight.current) && stateClasses.current.animatingDown, timeoutHeight === 0 && stateClasses.current.animatingToHeightZero, timeoutHeight === 'auto' && stateClasses.current.animatingToHeightAuto, timeoutHeight > 0 && stateClasses.current.animatingToHeightSpecific].filter(function (v) {
        return v;
      }).join(' ');
      // Animation classes to be put after animation is complete
      var timeoutAnimationStateClasses = getStaticStateClasses(stateClasses.current, timeoutHeight);
      // Set starting height and animating classes
      // When animating from 'auto' we first need to set fixed height
      // that change should be animated
      setCurrentHeight(newHeight);
      setOverflow('hidden');
      setUseTransitions(!isCurrentHeightAuto);
      setAnimationStateClassNames(newAnimationStateClassNames);
      // Clear timeouts
      clearTimeout(timeoutID.current);
      clearTimeout(animationClassesTimeoutID.current);
      if (isCurrentHeightAuto) {
        // When animating from 'auto' we use a short timeout to start animation
        // after setting fixed height above
        timeoutUseTransitions = true;
        // Short timeout to allow rendering of the initial animation state first
        timeoutID.current = setTimeout(function () {
          setCurrentHeight(timeoutHeight);
          setOverflow(timeoutOverflow);
          setUseTransitions(timeoutUseTransitions);
          // ANIMATION STARTS, run a callback if it exists
          onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(timeoutHeight);
        }, 50);
        // Set static classes and remove transitions when animation ends
        animationClassesTimeoutID.current = setTimeout(function () {
          setUseTransitions(false);
          setAnimationStateClassNames(timeoutAnimationStateClasses);
          // ANIMATION ENDS
          // Hide content if height is 0 (to prevent tabbing into it)
          hideContent(contentElement.current, timeoutHeight);
          // Run a callback if it exists
          onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(timeoutHeight);
        }, totalDuration);
      } else {
        // ANIMATION STARTS, run a callback if it exists
        onHeightAnimationStart === null || onHeightAnimationStart === void 0 ? void 0 : onHeightAnimationStart(newHeight);
        // Set end height, classes and remove transitions when animation is complete
        timeoutID.current = setTimeout(function () {
          setCurrentHeight(timeoutHeight);
          setOverflow(timeoutOverflow);
          setUseTransitions(false);
          setAnimationStateClassNames(timeoutAnimationStateClasses);
          // ANIMATION ENDS
          // If height is auto, don't hide the content
          // (case when element is empty, therefore height is 0)
          if (height !== 'auto') {
            // Hide content if height is 0 (to prevent tabbing into it)
            hideContent(contentElement.current, newHeight); // TODO solve newHeight = 0
          }
          // Run a callback if it exists
          onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 ? void 0 : onHeightAnimationEnd(newHeight);
        }, totalDuration);
      }
    }
    prevHeight.current = height;
    return function () {
      clearTimeout(timeoutID.current);
      clearTimeout(animationClassesTimeoutID.current);
    };
    // This should be explicitly run only on height change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);
  // ------------------ Render
  var componentStyle = Object.assign(Object.assign({}, style), {
    height: currentHeight,
    overflow: overflow || (style === null || style === void 0 ? void 0 : style.overflow)
  });
  if (useTransitions && applyInlineTransitions) {
    componentStyle.transition = "height ".concat(duration, "ms ").concat(easing, " ").concat(delay, "ms");
    // Include transition passed through styles
    if (style === null || style === void 0 ? void 0 : style.transition) {
      componentStyle.transition = "".concat(style.transition, ", ").concat(componentStyle.transition);
    }
    // Add webkit vendor prefix still used by opera, blackberry...
    componentStyle.WebkitTransition = componentStyle.transition;
  }
  var contentStyle = {};
  if (animateOpacity) {
    contentStyle.transition = "opacity ".concat(duration, "ms ").concat(easing, " ").concat(delay, "ms");
    // Add webkit vendor prefix still used by opera, blackberry...
    contentStyle.WebkitTransition = contentStyle.transition;
    if (currentHeight === 0) {
      contentStyle.opacity = 0;
    }
  }
  // Check if user passed aria-hidden prop
  var hasAriaHiddenProp = typeof divProps['aria-hidden'] !== 'undefined';
  var ariaHidden = hasAriaHiddenProp ? divProps['aria-hidden'] : height === 0;
  return React.createElement("div", Object.assign({}, divProps, {
    "aria-hidden": ariaHidden,
    className: "".concat(animationStateClassNames, " ").concat(className),
    style: componentStyle
  }), React.createElement("div", {
    className: contentClassName,
    style: contentStyle,
    ref: contentElement
  }, children));
};
export default AnimateHeight;